import { inboxTemplatesConstants } from '@constants/inbox-templates';
import { inboxTemplatesService } from '@services';

export const inboxTemplatesActions = {
    getAll,
};

function getAll() {
    return dispatch => {
        dispatch(request());
        inboxTemplatesService.getAllInboxTemplates().then(
            data => dispatch(successAllActive(data)),
            () => dispatch(failure()),
        );
    };
}

function request() {
    return { type: inboxTemplatesConstants.INBOX_TEMPLATES_REQUEST };
}

function failure() {
    return { type: inboxTemplatesConstants.INBOX_TEMPLATES_ERROR };
}

function successAllActive(data) {
    return { type: inboxTemplatesConstants.INBOX_ALL_ACTIVE_TEMPLATES_SUCCESS, data };
}
